import Routes from "@/router/Routes";

export default function routesList() {
	return {
		routeList: Routes
	};
}
